import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

import Checkbox from '@mui/material/Checkbox';


import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/AccordionDetails';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import QualificationTextField from 'components/Shared/QualificationTextField';
import DepotGestionSelect from 'components/Shared/DepotGestionSelect';
import AdresseForm from 'components/Shared/AdresseForm';

import MyDatePicker from 'components/Shared/MyDatePicker';
import NumeroCompteFoussierTextField from 'components/Shared/NumeroCompteFoussierTextField';


import { GarantieType } from 'constants.js';


const renvoiLabel = "Où renvoyer le produit après réparation ?";
const renvois = [
    "Dans un magasin",
    "Chez le client"
];





const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },

    group: {
        margin: theme.spacing(1, 0)
    },
});

class PriseEnCharge extends QualificationComponent {


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,
            designation: props.designation,
            designationDisabled: props.designation !== '',
            codeArticle: props.codeArticle,
            codeArticleDisabled: props.designation !== '',
            marque: '',
            referenceNumerique: '',
            referenceNumeriqueObligatoire: props.fournisseurCode === '00652',
            numeroSerie: '',
            dateAchat: props.dateAchat,
            dateAchatDisabled: !!props.dateAchat,
            numeroPiece: props.numeroPiece,
            numeroPieceDisabled: props.numeroPiece !== '',

            concerneAccessoire: false,
            concerneAccessoireBatterie: false,
            concerneAccessoireChargeur: false,
            concerneAccessoireAutre: false,
            concerneAccessoireCommentaire: '',


            motif: '',

            nbBatterie: 0,
            nbChargeur: 0,
            nbSystainer: 0,
            nbMandrin: 0,
            autres: '',
            aucune: false,
            commentaires: '',

            articlePreter: '',
            articlePreterPiece: '',
            commentaireTraitement: '',

            numeroCompteFoussier: '',


            [ReclamationQualificationDetailCodes.Renvoi]: '',
            [ReclamationQualificationDetailCodes.AdresseRenvoi]: '',
            [ReclamationQualificationDetailCodes.MagasinRenvoi]: this.props.reclamation.magasin ? this.props.reclamation.magasin.codeDepot : '',
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.DetailSavTypeProduit,
            ReclamationQualificationDetailCodes.DetailSavCodeArticle,
            ReclamationQualificationDetailCodes.DetailSavMarque,
            ReclamationQualificationDetailCodes.DetailSavReferenceNumerique,
            ReclamationQualificationDetailCodes.DetailSavNumeroSerie,
            ReclamationQualificationDetailCodes.DetailSavDateAchat,
            ReclamationQualificationDetailCodes.DetailSavBLOuFacture,

            ReclamationQualificationDetailCodes.DetailSavConcerneAccessoire,
            ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireBatterie,
            ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireChargeur,
            ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireAutre,
            ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireCommentaire,

            ReclamationQualificationDetailCodes.DetailSavMotif,

            ReclamationQualificationDetailCodes.DetailSavRestitutionNbBatterie,
            ReclamationQualificationDetailCodes.DetailSavRestitutionNbChargeur,
            ReclamationQualificationDetailCodes.DetailSavRestitutionNbSystainer,
            ReclamationQualificationDetailCodes.DetailSavRestitutionNbMandrin,
            ReclamationQualificationDetailCodes.DetailSavRestitutionAucune,
            ReclamationQualificationDetailCodes.DetailSavRestitutionAutres,
            ReclamationQualificationDetailCodes.DetailSavCommentaires,

            ReclamationQualificationDetailCodes.DetailSavArticlePreter,
            ReclamationQualificationDetailCodes.DetailSavArticlePreterPiece,
            ReclamationQualificationDetailCodes.DetailSavCommentaireTraitement,

            ReclamationQualificationDetailCodes.DetailSavNumeroCompteFoussier,

            ReclamationQualificationDetailCodes.Renvoi,
            ReclamationQualificationDetailCodes.AdresseRenvoi,
            ReclamationQualificationDetailCodes.MagasinRenvoi,

        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");
    }



    handleChangeAucuneRestitution = (event) => {
        const { onChange, name } = this.props;

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value,
            nbBatterie: 0,
            nbChargeur: 0,
            nbSystainer: 0,
            nbMandrin: 0,
            autres: '',
        };
        this.setState(newState);

        const { position, toAdd, toDelete } = this.getQualificationData(newState);

        onChange(name, position, toAdd, toDelete, "Life");
    }

    handleChangeConcerneAccessoire = (event) => {
        const { onChange, name } = this.props;

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value,
            concerneAccessoireBatterie: false,
            concerneAccessoireChargeur: false,
            concerneAccessoireAutre: false,
            concerneAccessoireCommentaire: '',
        };
        this.setState(newState);

        const { position, toAdd, toDelete } = this.getQualificationData(newState);

        onChange(name, position, toAdd, toDelete, "Life");
    }

    getQualificationData(newState) {
        const { name, renvoiRequis, garantie } = this.props;

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];


        if (
               newState.designation === ''
            || newState.codeArticle === ''
            || newState.marque === ''
            || (newState.referenceNumerique === '' && newState.referenceNumeriqueObligatoire)
            || newState.numeroSerie === ''
            || newState.motif === ''
            || (newState.articlePreter && newState.articlePreterPiece === '')
            || (renvoiRequis && newState[ReclamationQualificationDetailCodes.Renvoi] === '')
            || (newState[ReclamationQualificationDetailCodes.Renvoi] === '0' && newState[ReclamationQualificationDetailCodes.MagasinRenvoi] === '')
            || (newState[ReclamationQualificationDetailCodes.Renvoi] === '1' && newState[ReclamationQualificationDetailCodes.AdresseRenvoi] === '')
            || (garantie === GarantieType.SousGarantieApresUtilisation && newState.dateAchat === null)
            || (garantie === GarantieType.SousGarantieApresUtilisation && newState.numeroPiece === '')
        ) {
            return {
                name: name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavTypeProduit,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Type de produit",
            valeurString: newState.designation
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavTypeProduit);

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavCodeArticle,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Code",
            valeurString: newState.codeArticle
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavCodeArticle);

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavMarque,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Marque",
            valeurString: newState.marque
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavMarque);

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavReferenceNumerique,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Ref. numérique Machine (Bosch)",
            valeurString: newState.referenceNumerique
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavReferenceNumerique);

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavNumeroSerie,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "N° Série",
            valeurString: newState.numeroSerie
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavNumeroSerie);

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavDateAchat,
            type: ReclamationQualificationDetailType.Date,
            libelle: "Date Achat",
            valeurDate: newState.dateAchat
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavDateAchat);

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavBLOuFacture,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "N° BL ou Facture",
            valeurString: newState.numeroPiece
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavBLOuFacture);



        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavConcerneAccessoire,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: "Le SAV concerne un accessoire de l'article",
            valeurBool: newState.concerneAccessoire
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavConcerneAccessoire);

        if (newState.concerneAccessoire)
        {
            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireBatterie,
                type: ReclamationQualificationDetailType.Booleen,
                libelle: "Batterie",
                valeurBool: newState.concerneAccessoireBatterie
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireBatterie);

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireChargeur,
                type: ReclamationQualificationDetailType.Booleen,
                libelle: "Chargeur",
                valeurBool: newState.concerneAccessoireChargeur
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireChargeur);

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireAutre,
                type: ReclamationQualificationDetailType.Booleen,
                libelle: "Autre",
                valeurBool: newState.concerneAccessoireAutre
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireAutre);

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireCommentaire,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Commentaire",
                valeurString: newState.concerneAccessoireCommentaire
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavConcerneAccessoireCommentaire);
        }



        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavMotif,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Motif SAV",
            valeurString: newState.motif
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavMotif);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavRestitutionAucune,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: "Aucune restitution d'accessoires.",
            valeurBool: newState.aucune
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionAucune);

        if (!newState.aucune) {

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionNbBatterie,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Batterie",
                valeurInteger: newState.nbBatterie
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionNbBatterie);

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionNbChargeur,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Chargeur",
                valeurInteger: newState.nbChargeur
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionNbChargeur);

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionNbSystainer,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Systainer",
                valeurInteger: newState.nbSystainer
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionNbSystainer);

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionNbMandrin,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Mandrin",
                valeurInteger: newState.nbMandrin
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionNbMandrin);



            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionAutres,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Autres accessoires",
                valeurString: newState.autres
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionAutres);

        }



        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavCommentaires,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Commentaires",
            valeurString: newState.commentaires
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavCommentaires);




        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavArticlePreter,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: "Un article de prêt a été donné au client",
            valeurBool: newState.articlePreter
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavArticlePreter);


        if (newState.articlePreter) {
            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavArticlePreterPiece,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Numéro pièce (article de prêt donner au client) :",
                valeurString: newState.articlePreterPiece
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavArticlePreterPiece);
        }




        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavCommentaireTraitement,
            type: ReclamationQualificationDetailType.Texte, 
            libelle: "Commentaire",
            valeurString: newState.commentaireTraitement
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavCommentaireTraitement);




        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavNumeroCompteFoussier,
            type: ReclamationQualificationDetailType.Texte, 
            libelle: "Numéro de compte Foussier (chez le réparateur)",
            valeurString: newState.numeroCompteFoussier
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavNumeroCompteFoussier);



        if (renvoiRequis) {

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.Renvoi,
                type: ReclamationQualificationDetailType.ChoixSimple,
                libelle: renvoiLabel,
                valeurInteger: newState[ReclamationQualificationDetailCodes.Renvoi],
                valeurString: renvois[newState[ReclamationQualificationDetailCodes.Renvoi]]
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.Renvoi)

            if (newState[ReclamationQualificationDetailCodes.Renvoi] === "0") {


                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.MagasinRenvoi,
                    type: ReclamationQualificationDetailType.CodeDepot,
                    libelle: renvois[0],
                    valeurString: newState[ReclamationQualificationDetailCodes.MagasinRenvoi]
                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.MagasinRenvoi)

            }

            if (newState[ReclamationQualificationDetailCodes.Renvoi] === "1") {


                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.AdresseRenvoi,
                    type: ReclamationQualificationDetailType.Texte,
                    libelle: "Adresse de renvoi",
                    valeurString: newState[ReclamationQualificationDetailCodes.AdresseRenvoi],

                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.AdresseRenvoi);

            }
        }

        
        return {
            name: name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }




    render() {
        const { name, classes, renvoiRequis, adresseRenvoi, garantie, reclamation } = this.props;

        const { designation, designationDisabled } = this.state;
        const { codeArticle, codeArticleDisabled } = this.state;
        const { marque } = this.state;
        const { referenceNumerique, referenceNumeriqueObligatoire } = this.state;
        const { numeroSerie } = this.state;
        const { dateAchat, dateAchatDisabled } = this.state;
        const { numeroPiece, numeroPieceDisabled } = this.state;

        const { concerneAccessoire, concerneAccessoireBatterie, concerneAccessoireChargeur, concerneAccessoireAutre, concerneAccessoireCommentaire } = this.state;

        const { motif } = this.state;

        const { nbBatterie, nbChargeur, nbSystainer, nbMandrin, autres, aucune } = this.state;
        const { commentaires } = this.state;
        const { articlePreter, articlePreterPiece } = this.state;
        const { commentaireTraitement } = this.state;

        const { numeroCompteFoussier } = this.state;

        const renvoi = this.state[ReclamationQualificationDetailCodes.Renvoi];

        let depot = reclamation.qualificationDetails.find(x => x.code === ReclamationQualificationDetailCodes.Depot);
        let codeDepot = depot ? depot.valeurString : '';
        
        let fournisseurId = reclamation.lignes.length === 0 ? -1 : reclamation.lignes[0].fournisseur ? reclamation.lignes[0].fournisseur.id : -1

        return (


            <Accordion id={name} defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                    <Typography style={{ fontSize: 'large' }}>Informations complémentaires pour l'édition du document de prise en charge SAV et du document fournisseur</Typography>
                </AccordionSummary>

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>



                    <fieldset style={{ borderRadius: '8px' }}>
                        <legend>Produit</legend>

                        <QualificationTextField
                            label={"Type de produit"}
                            name={"designation"}
                            value={designation}
                            onChange={this.handleChange}
                            disabled={designationDisabled}
                            required
                        />

                        <QualificationTextField
                            label={"Code"}
                            name={"codeArticle"}
                            value={codeArticle}
                            disabled={codeArticleDisabled}
                            onChange={this.handleChange}
                            required
                        />

                        <QualificationTextField
                            label={"Marque"}
                            name={"marque"}
                            value={marque}
                            onChange={this.handleChange}
                            required
                        />

                        <QualificationTextField
                            label={"Ref. numérique Machine (Bosch)"}
                            name={"referenceNumerique"}
                            value={referenceNumerique}
                            onChange={this.handleChange}
                            required={referenceNumeriqueObligatoire}
                        />

                        <QualificationTextField
                            label={"N° Série"}
                            name={"numeroSerie"}
                            value={numeroSerie}
                            onChange={this.handleChange}
                            required
                        />

                        
                        <MyDatePicker
                            label="Date d'achat"
                            name={"dateAchat"}
                            value={dateAchat}
                            onChange={e => this.handleChange({ target: { name: "dateAchat", value: e } })}
                            disableFuture={true}
                            fullWidth
                            disabled={dateAchatDisabled}
                            required={garantie === GarantieType.SousGarantieApresUtilisation}
                        />


                        <QualificationTextField
                            sx={{ marginTop: '8px'}}
                            label={"N° BL ou Facture"}
                            name={"numeroPiece"}
                            value={numeroPiece}
                            disabled={numeroPieceDisabled}
                            onChange={this.handleChange}
                            required={garantie === GarantieType.SousGarantieApresUtilisation}
                        />



                        <FormControlLabel
                            control={
                                <Checkbox checked={concerneAccessoire === true} onChange={e => this.handleChangeConcerneAccessoire({ target: { name: "concerneAccessoire", value: concerneAccessoire === '' ? true : !concerneAccessoire } })} value="true" />
                            }
                            label={"Le SAV concerne un accessoire de l'article"}
                        />


                        {concerneAccessoire === true && (

                            <>

                                <FormControlLabel
                                    control={
                                        <Checkbox checked={concerneAccessoireBatterie === true} onChange={e => this.handleChange({ target: { name: "concerneAccessoireBatterie", value: concerneAccessoireBatterie === '' ? true : !concerneAccessoireBatterie } })} value="true" />
                                    }
                                    label={"Batterie"}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox checked={concerneAccessoireChargeur === true} onChange={e => this.handleChange({ target: { name: "concerneAccessoireChargeur", value: concerneAccessoireChargeur === '' ? true : !concerneAccessoireChargeur } })} value="true" />
                                    }
                                    label={"Chargeur"}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox checked={concerneAccessoireAutre === true} onChange={e => this.handleChange({ target: { name: "concerneAccessoireAutre", value: concerneAccessoireAutre === '' ? true : !concerneAccessoireAutre } })} value="true" />
                                    }
                                    label={"Autre"}
                                />


                                <QualificationTextField
                                    label={"Commentaires"}
                                    name={"concerneAccessoireCommentaire"}
                                    value={concerneAccessoireCommentaire}
                                    onChange={this.handleChange}
                                />
                            </>

                        )}


                    </fieldset>

                    <fieldset style={{ borderRadius: '8px' }}>
                        <legend>Detail SAV</legend>



                        <QualificationTextField
                            label={"Motif SAV"}
                            name={"motif"}
                            value={motif}
                            onChange={this.handleChange}
                            required
                            placeholder={"Type de panne: Mandrin, bruit moteur, étincelle ..."}
                        />


                        <FormControlLabel
                            control={
                                <Checkbox checked={aucune === true} onChange={e => this.handleChangeAucuneRestitution({ target: { name: "aucune", value: aucune === '' ? true : !aucune } })} value="true" />
                            }
                            label={"Aucune restitution d'accessoires"}
                        />

                        {aucune === false && (

                            <>

                                <QualificationTextField
                                    label={"Batterie"}
                                    name={"nbBatterie"}
                                    value={nbBatterie}
                                    onChange={this.handleChange}
                                    type="number"
                                    inputProps={{ min: 0 }}
                                    disabled={aucune === true}
                                />

                                <QualificationTextField
                                    label={"Chargeur"}
                                    name={"nbChargeur"}
                                    value={nbChargeur}
                                    onChange={this.handleChange}
                                    type="number"
                                    inputProps={{ min: 0 }}
                                    disabled={aucune === true}
                                />

                                <QualificationTextField
                                    label={"Systainer"}
                                    name={"nbSystainer"}
                                    value={nbSystainer}
                                    onChange={this.handleChange}
                                    type="number"
                                    inputProps={{ min: 0 }}
                                    disabled={aucune === true}
                                />

                                <QualificationTextField
                                    label={"Mandrin"}
                                    name={"nbMandrin"}
                                    value={nbMandrin}
                                    onChange={this.handleChange}
                                    type="number"
                                    inputProps={{ min: 0 }}
                                    disabled={aucune === true}
                                />





                                <QualificationTextField
                                    label={"Autres accessoires"}
                                    name={"autres"}
                                    value={autres}
                                    onChange={this.handleChange}
                                    disabled={aucune === true}
                                />
                            </>
                            
                        )}



                        <QualificationTextField
                            label={"Commentaires"}
                            name={"commentaires"}
                            value={commentaires}
                            onChange={this.handleChange}
                            multiline
                        />

                    </fieldset>

                    <fieldset style={{ borderRadius: '8px' }}>
                        <legend>Traitement du SAV</legend>


                        <FormControlLabel
                            control={
                                <Checkbox checked={articlePreter === true} onChange={e => this.handleChange({ target: { name: "articlePreter", value: articlePreter === '' ? true : !articlePreter } })} value="true" />
                            }
                            label={"Un article de prêt a été donné au client"}
                        />

                        {articlePreter && (
                            <QualificationTextField
                                label={"Numéro de pièce"}
                                name={"articlePreterPiece"}
                                value={articlePreterPiece}
                                onChange={this.handleChange}
                                required
                            />
                        )}




                        <QualificationTextField
                            label={"Commentaire"}
                            name={"commentaireTraitement"}
                            value={commentaireTraitement}
                            onChange={this.handleChange}
                            multiline
                        />

                    </fieldset>

                    <div style={{ paddingTop: '8px' }}>
                        <NumeroCompteFoussierTextField                         
                            label={"Numéro de compte Foussier (chez le réparateur)"}
                            name={"numeroCompteFoussier"}
                            value={numeroCompteFoussier}
                            onChange={this.handleChange}
                            codeDepot={codeDepot}
                            fournisseurId={fournisseurId}
                        />
                    </div>

                    {renvoiRequis && (

                        <React.Fragment>

                            <FormControl required className={classes.formControl}>
                                <FormLabel>{renvoiLabel}</FormLabel>
                                <RadioGroup
                                    name={ReclamationQualificationDetailCodes.Renvoi}
                                    className={classes.group}
                                    value={renvoi}
                                    onChange={this.handleChange}
                                >
                                    {renvois.map((reponse, index) => (
                                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                    ))}
                                </RadioGroup>
                            </FormControl>

                            {/* Magasin */}
                            {renvoi === '0' && (

                                <DepotGestionSelect className={classes.formControl}
                                    value={this.state[ReclamationQualificationDetailCodes.MagasinRenvoi]}
                                    valueIsCode
                                    onChange={(e, codeDepot) => {
                                        this.handleChange({
                                            target: {
                                                name: ReclamationQualificationDetailCodes.MagasinRenvoi,
                                                value: codeDepot
                                            }
                                        });
                                    }}
                                    magasinsSeulement
                                    isRequired
                                    autoFocus
                                    label="Sélectionner un magasin :"
                                    modeTri={1}
                                    disabled={reclamation.magasin && reclamation.magasin.verrou}
                                />
                            )}

                            {/* Chez le client */}
                            {renvoi === '1' && (

                                <AdresseForm
                                    label={"Adresse de renvoi"}
                                    adresse={adresseRenvoi}
                                    onChange={(addr, addrStr) => this.handleChange({ target: { name: ReclamationQualificationDetailCodes.AdresseRenvoi, value: addrStr } })}
                                />
                            )}






                        </React.Fragment>
                    )}


                </AccordionDetails>
            </Accordion>

        );
    }

}


PriseEnCharge.propTypes = {
    name: PropTypes.string.isRequired,
    garantie: PropTypes.number,
    renvoiRequis: PropTypes.bool,
    adresseRenvoi: PropTypes.object,


    designation: PropTypes.string,
    codeArticle: PropTypes.string,
    fournisseurCode: PropTypes.string,

    reclamation: PropTypes.object.isRequired,
};

PriseEnCharge.defaultProps = {
    garantie: GarantieType.SousGarantieApresUtilisation
};

export default withStyles(styles)(PriseEnCharge);